module.exports = __webpack_public_path__ + "img/inverter-ranking.4ff7b9b5.svg";